import { z } from 'zod';

// A single ticket-label row. Mirrors the legacy
// `travel_planner_back/src/settings/entities/ticket-label.entity.ts` shape.
export const ticketLabelItemSchema = z.object({
  id: z.uuid(),
  label: z.string(),
});

export type TicketLabelItem = z.infer<typeof ticketLabelItemSchema>;

export const findTicketLabelsInput = z.object({
  offset: z.number().int().min(0).optional(),
  limit: z.number().int().min(1).max(500).optional(),
  label: z.string().optional(),
});

export type FindTicketLabelsInput = z.infer<typeof findTicketLabelsInput>;

export const findTicketLabelsResultSchema = z.object({
  data: z.array(ticketLabelItemSchema),
  count: z.number().int().nonnegative(),
  countAll: z.number().int().nonnegative(),
});

export type FindTicketLabelsResult = z.infer<
  typeof findTicketLabelsResultSchema
>;

// Replace-all semantics: every call wipes the org's existing labels and
// inserts the supplied list. Mirrors the legacy `POST /ticket-label`
// behaviour. Allow an empty array so the consumer can clear all labels.
export const replaceTicketLabelsInput = z.object({
  labels: z.array(z.string().trim().min(1)).max(500),
});

export type ReplaceTicketLabelsInput = z.infer<typeof replaceTicketLabelsInput>;

export const replaceTicketLabelsResultSchema = z.object({
  data: z.array(ticketLabelItemSchema),
  count: z.number().int().nonnegative(),
});

export type ReplaceTicketLabelsResult = z.infer<
  typeof replaceTicketLabelsResultSchema
>;

export const deleteTicketLabelInput = z.object({ id: z.uuid() });

export type DeleteTicketLabelInput = z.infer<typeof deleteTicketLabelInput>;

export const deleteTicketLabelResultSchema = z.object({ id: z.uuid() });

export type DeleteTicketLabelResult = z.infer<
  typeof deleteTicketLabelResultSchema
>;
